import { AxiosResponse } from "axios";
import { useEffect } from "react";
import { useContext, useRef, useState } from "react";
import { AdminFrame } from "views/common/AdminFrame";
import { getApiDataWithToken } from "views/utils/CallApi";
import { postApiDataWithToken } from "views/utils/CallApi";
import * as mb from "views/common/MessageBox";
import * as Validation from "views/utils/Validation";
import { CtxAuth } from "views/utils/Contexts";
import { getRef } from "views/utils/InputHelp";
import { setRef } from "views/utils/InputHelp";
import { getRefSelect } from "views/utils/InputHelp";
import { setRefSelect } from "views/utils/InputHelp";
import { getRefTextArea } from "views/utils/InputHelp";
import { setRefTextArea } from "views/utils/InputHelp";
import { Dialog } from "views/common/Dialog";
import { string8ToFormatDateString, getTimeRange, spaceSplit, conmaSplit, getCurrentTime, scrollTop } from "views/utils/CommonFunc";
import { InputDate } from "views/common/InputDate";

interface IFOrderHistory {
    orderNo: string,
    createDate: string,
    updateDate: string,
    firstTimeFlg: number,
    orderStatus: number,
    orderName: string,
    furigana: string,
    zip: string,
    address: string,
    phone: string,
    mailAddress: string,
    orderComment: string,
    orderTotalPrice: string,
    billingPrice: string,
    claimMemo: string,
    billingDate: string,
    memo: string,
    scheduledDate: string,
    reserveDate1: string,
    reserveDateStart1: string,
    reserveDateEnd1: string,
    reserveDate2: string,
    reserveDateStart2: string,
    reserveDateEnd2: string,
    reserveDate3: string,
    reserveDateStart3: string,
    reserveDateEnd3: string,
    parkingSpaceFlg: number,
    frameNo: number,
    patternId: string,
    scheduleNo: number
}

interface IFServiceHistory {
    serviceId: number,
    serviceName: string,
    servicePrice: number,
    serviceQuantity: number,
    serviceTotalPrice: number
}

interface IFOptionHistory {
    optionId: number,
    optionServiceId: number,
    optionName: string,
    optionPrice: number,
    optionQuantity: number,
    optionTotalPrice: number
}

interface IFScheduledHistory {
    frameNo: number,
    scheduleStartTime: string,
    scheduleEndTime: string,
    status: number,
    patternId: string,
    scheduleNo: number
}

interface IFSum {
    sum: number
}

export function OrderEdit(): JSX.Element{

    const [isShow, setIsShow] = useState<boolean>(false);
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);
    const [mailCheckBox, setMailCheckBox] = useState<boolean>(false);
    const cua = useContext(CtxAuth);
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [orderHistory, setOrderHistory] = useState<IFOrderHistory>({
            orderNo:"",
            createDate:getCurrentTime(new Date()),
            updateDate:getCurrentTime(new Date()),
            firstTimeFlg:0,
            orderStatus:10,
            orderName:"",
            furigana:"",
            zip:"",
            address:"",
            phone:"",
            mailAddress:"",
            orderComment:"",
            orderTotalPrice:"",
            billingPrice:"",
            claimMemo:"",
            billingDate:"",
            memo:"",
            scheduledDate:"",
            reserveDate1:"",
            reserveDateStart1:"",
            reserveDateEnd1:"",
            reserveDate2:"",
            reserveDateStart2:"",
            reserveDateEnd2:"",
            reserveDate3:"",
            reserveDateStart3:"",
            reserveDateEnd3:"",
            parkingSpaceFlg:2,
            frameNo:0,
            patternId:"",
            scheduleNo:0
        }
    );
    const [serviceHistory, setServiceHistory] = useState<IFServiceHistory[]>();
    const [optionHistory, setOptionHistory] = useState<IFOptionHistory[]>();
    const [patternId, setPatternId] = useState<number>(0);
    const [scheduleNo, setScheduleNo] = useState<number>(0);
    const [billingDate, setBillingDate] = useState<string>();
    const [sum, setSum] = useState<IFSum[]>();
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const orderNo = useRef<HTMLInputElement>(null);
    const orderStatus = useRef<HTMLSelectElement>(null);
    const orderName = useRef<HTMLInputElement>(null);
    const zip = useRef<HTMLInputElement>(null);
    const furigana = useRef<HTMLInputElement>(null);
    const address = useRef<HTMLInputElement>(null);
    const phone = useRef<HTMLInputElement>(null);
    const mailAddress = useRef<HTMLInputElement>(null);
    const orderComment = useRef<HTMLTextAreaElement>(null);
    const billingPrice = useRef<HTMLInputElement>(null);
    const updateDate = useRef<HTMLInputElement>(null);
    const memo = useRef<HTMLTextAreaElement>(null);
    const claimMemo = useRef<HTMLInputElement>(null);
    const dayWeek = ["（日）", "（月）", "（火）", "（水）", "（木）", "（金）", "（土）" ] 
    const scheduledDate = useRef<HTMLInputElement>(null);
    const frameNoRef = useRef<HTMLSelectElement>(null);
    const [scheduledHistory, setScheduledHistory] = useState<IFScheduledHistory[]>();
    const [priceChangeFlag, setPriceChangeFlag] = useState<number>(0);
    const [orderStatusState, setOrderStatusState] = useState<string>("0");
    const [message, setMessage] = useState<string>("");
    const mailRef = useRef<HTMLInputElement>(null);
    const [changeSccess, setChangeSccess] = useState({text:""});

    //変更を保存ボタン押下時
    function clickSave(){
        //ボタンを押したタイミングで非活性にする
        setSubmitDisabled(true);
        //画面トップに遷移する
        scrollTop();

        //バリデーションチェック
        let errmsg:string;

        //ステータスが10（受注中）かつ99（キャンセル）以外の場合
        //確定日入力チェック
        if (getRefSelect(orderStatus) !== "10" && getRefSelect(orderStatus) !== "99") {
            if (getRef(scheduledDate) === null || getRefSelect(frameNoRef).length === 0) {
                errmsg = Validation.checkEmptyTextBox(getRefSelect(frameNoRef), "確定日時")
                if (errmsg){
                    setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
                    //ボタンを活性にする
                    setSubmitDisabled(false);
                    setIsShow(false);
                    return false;
                }
            }
        }

        //数値チェック（マイナス禁止）
        errmsg = Validation.checkNumberMinus((getRef(billingPrice)), "請求金額")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            setIsShow(false);
            return false;
        }

        //整数チェック
        errmsg = Validation.checkPositiveInteger(Number(getRef(billingPrice)), "請求金額")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            setIsShow(false);
            return false;
        }

        //桁数制限
        errmsg = Validation.checkLengthOver(getRef(billingPrice), 8, "請求金額")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            setIsShow(false);
            return false;
        }

        //金額変更理由文字数制限
        errmsg = Validation.checkLengthOver(getRef(claimMemo), 200, "金額変更理由")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            setIsShow(false);
            return false;
        }

        //メモ文字数制限
        errmsg = Validation.checkLengthOver(getRefTextArea(memo), 1000, "メモ")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            setIsShow(false);
            return false;
        }

        //frameNo取得
        var frameGet = ""
        if (getRefSelect(frameNoRef).length === 0) {
            frameGet = "0"
        } else {
            frameGet = getRefSelect(frameNoRef).split(":")[1];
        }

        //請求金額確定日取得
        var billing_date = ""
        if (billingDate != null){
            if (priceChangeFlag === 0) {
                billing_date = billingDate;
            } else {
                billing_date = getCurrentTime(new Date());
            }
        }

        //入力内容を登録するAPI
        postApiDataWithToken('/management/orders/update',
            {
                'order_no': params.get('orderNo'),
                'order_status': getRefSelect(orderStatus),
                'billing_price': getRef(billingPrice),
                'billing_date': billing_date,
                'claim_memo': getRef(claimMemo),
                'scheduled_date': getRef(scheduledDate),
                'memo': getRefTextArea(memo),
                'update_date': getCurrentTime(new Date()),
                'update_operator_id': sessionStorage.getItem('operator_id'),
                'schedule_no': scheduleNo,
                'pattern_id': patternId,
                'frame_no': frameGet
            },
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"注文更新が完了しました。"});
                        setChangeSccess({text: "1"});
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"注文更新に失敗しました。"});
                }
            }
        );

        //メール送信するAPI
        if (mailRef.current !== null){
            if(mailRef.current.checked){
                let message = ""
                message += orderHistory.orderName + "様\n"
                message += "お申込番号：" + params.get('orderNo') +"\n"
                message += "\n"
                message += "この度は、当社Webサイトよりご予約いただきまして、誠にありがとうございました。\n"
                message += "予約日時が確定致しましたので、ご連絡させていただきます。\n"
                message += "予約につきましては、下記の通りでございます。\n"
                message += "\n"
                message += "予約氏名：" + orderHistory.orderName + "\n"
                message += "予約日時：" + string8ToFormatDateString(getRef(scheduledDate).replace(/-/g, ''))
                if (scheduledHistory != null){
                    for (let ind = 0; ind < scheduledHistory.length; ind++){
                        if (scheduledHistory[ind].frameNo === Number(frameGet)){
                            message +=  scheduledHistory[ind].scheduleStartTime.slice(0, -3) + " ～ " + scheduledHistory[ind].scheduleEndTime.slice(0, -3) + "\n"
                        }
                    }
                }
                message += "予約内容\n"
                if (serviceHistory != null) {
                    for (let index = 0; index < serviceHistory.length; index++) {
                        var count = 0;
                        message += "　　サービス　：　" + serviceHistory[index].serviceName + "\n"
                        if (optionHistory != null) {
                            for (let ind = 0; ind < optionHistory.length; ind++) {
                                if (serviceHistory[index].serviceId === optionHistory[ind].optionServiceId) {
                                    if (count === 0) {
                                        message += "　　オプション：　" + optionHistory[ind].optionName + "\n"
                                        count++
                                    } else {
                                        message += "　　　　　　　　　" + optionHistory[ind].optionName + "\n"
                                        count++
                                    }
                                }
                            }
                        }
                        message += "\n"
                    }
                }
                message += "料金　　：" + getRef(billingPrice).toLocaleString() + "円（税込）\n"
                message += "\n"
                message += "※当日、追加メニューをご利用された場合は金額が変更となります\n"
                message += "※お支払いは、現金、クレジットカード決済、キャッシュレス決済がご利用いただけます\n"
                message += "\n"
                message += "何かございましたら、下記連絡先までご連絡をお願い致します。\n"
                message += "連絡先：070-8405-1995（代表：小澤）\n"
                message += "【当日の注意事項について】\n"
                message += "・予約時間につきましては、おおよその目安になりますので、\n"
                message += "　時間が前後する可能性がございますので、ご了承ください。\n"
                message += "\n"
                message += "\n"
                message += "【キャンセルについて】\n"
                message += "キャンセルはご予約日の2日前までにご連絡ください。\n"
                message += "無断キャンセルの場合は料金の100％のキャンセル料を頂戴します。\n"
                message += "予約に関するご連絡先：070-8405-1995（受付時間：10時～18時）\n"
                message += "\n"
                message += "合同会社SEISHO\n"
                message += "代表　：小澤\n"
                message += "連絡先：070-8405-1995\n"

                postApiDataWithToken('/management/mail',
                {
                    'mail_address': getRef(mailAddress),
                    "mail_message": message
                },
                cua.getToken(),
                function(res:AxiosResponse<any>){
                    switch (res.status){
                        case 200:
                            setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"注文更新・メール送信が完了しました。"});
                            break;
                        default:
                            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"注文更新は成功しましたが、メール送信に失敗しました。何度も失敗する場合は大変お手数をおかけいたしますが、こちらにご連絡ください。 Tel:045-534-4187"});
                        }
                    }
                );
            }
        }
        //ボタンを活性にする
        setSubmitDisabled(false);
        setIsShow(false);
    }

    //選択したステータスを取得
    const selectStatus = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = String(event.target.value)
        setRefSelect(orderStatus,value);
        setOrderStatusState(value);
    }

    //請求金額の変更フラグ
    const priceChangeCheck = () => {
        setPriceChangeFlag(1)
    }
    //モーダルを開く
    function clickOpen(){
        if (getRefSelect(orderStatus) === "10"){
            setMessage("変更を保存しますか？ステータス【受注中】の場合、確定日時は更新されません。")
        } else {
            setMessage("変更を保存しますか？")
        }
    setIsShow(true);
    }

    //確定日時：選択日に対する時間リストを取得
    function getScheduleDate(){

        var day = getRef(scheduledDate).split("-");
        var fullDay = day[0] + day[1] + day[2];
        const scHistory:IFScheduledHistory[] = [];
        getApiDataWithToken(`/management/schedules/schedule/${fullDay}`,
        {},
        cua.getToken(),
        function(res:AxiosResponse<any>){
            switch (res.status){
                case 200:
                    if(res.data.days_list.length !== 0){
                        for (let index = 0; index < res.data.days_list[0].calandar_list.length; index++){
                            scHistory.push({frameNo:res.data.days_list[0].calandar_list[index].frame_no,
                                scheduleStartTime:res.data.days_list[0].calandar_list[index].schedule_start_time,
                                scheduleEndTime:res.data.days_list[0].calandar_list[index].schedule_end_time,
                                status:res.data.days_list[0].calandar_list[index].status,
                                patternId:res.data.days_list[0].pattern_id,
                                scheduleNo:res.data.days_list[0].schedule_no
                            });
                        }
                        setPatternId(res.data.days_list[0].pattern_id)
                        setScheduleNo(res.data.days_list[0].schedule_no)
                    } else {
                        scHistory.push({frameNo:0,
                            scheduleStartTime:"",
                            scheduleEndTime:"",
                            status:0,
                            patternId:"",
                            scheduleNo:0
                        });
                    }
                    setScheduledHistory(scHistory);
                    break;
                case 400:
                    setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"確定日に正しい日付を選択してください。"});
                    break;
                default:
                    //画面のロード失敗時にボタンを非活性にする
                    setSubmitDisabled(true);
                    setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                }
            }
        );
    }

    //確定時間が選択された時に実行する
    useEffect(function(){
        if (orderHistory.scheduledDate != null){
            setRefSelect(frameNoRef, orderHistory.patternId + ":" + orderHistory.frameNo);
        }
    }, [scheduledHistory]);

    //ステータス『キャンセル』の場合にチェックボックスを非活性
    useEffect(function(){
        if (orderStatusState === "10" || orderStatusState === "99") {
            if (mailRef.current !== null){
            mailRef.current.checked = false
            setMailCheckBox(true);
            }
        } else {
            setMailCheckBox(false);
        }
        
    }, [orderStatusState]);

    useEffect(function(){

        let orHistory:IFOrderHistory = {...orderHistory};
        if (params.get('orderNo') != null) {
            //変更の場合
            const svHistory:IFServiceHistory[] = [];
            const opHistory:IFOptionHistory[] = [];
            const sumInt:IFSum[] = [];
            var sumPrice = 0;
            getApiDataWithToken(`/management/orders/${params.get('orderNo')}`,
            {},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        orHistory.orderNo = res.data.order_no;
                        orHistory.createDate = res.data.create_date;
                        orHistory.updateDate = res.data.update_date;
                        orHistory.firstTimeFlg = res.data.property_list.first_time_flg;
                        orHistory.orderStatus = res.data.order_status;
                        orHistory.orderName = res.data.order_name;
                        orHistory.furigana = res.data.furigana;
                        orHistory.zip = res.data.zip;
                        orHistory.address = res.data.address;
                        orHistory.phone = res.data.phone;
                        orHistory.mailAddress = res.data.email_address;
                        orHistory.orderComment = res.data.order_comment;
                        orHistory.orderTotalPrice = res.data.order_total_price;
                        orHistory.billingPrice = res.data.billing_price;
                        orHistory.claimMemo = res.data.claim_memo;
                        orHistory.billingDate = res.data.billing_date;
                        orHistory.memo = res.data.memo;
                        orHistory.scheduledDate = res.data.scheduled_date;
                        orHistory.reserveDate1 = res.data.reserve_date_1;
                        orHistory.reserveDateStart1 = res.data.reserve_date_start_1;
                        orHistory.reserveDateEnd1 = res.data.reserve_date_end_1;
                        orHistory.reserveDate2 = res.data.reserve_date_2;
                        orHistory.reserveDateStart2 = res.data.reserve_date_start_2;
                        orHistory.reserveDateEnd2 = res.data.reserve_date_end_2;
                        orHistory.reserveDate3 = res.data.reserve_date_3;
                        orHistory.reserveDateStart3 = res.data.reserve_date_start_3;
                        orHistory.reserveDateEnd3 = res.data.reserve_date_end_3;
                        orHistory.parkingSpaceFlg = res.data.property_list.parking_space_flg;
                        if(res.data.scheduled_date != null){
                            //確定日時が設定済みの場合
                            orHistory.frameNo = res.data.frame_no;
                            orHistory.patternId = res.data.pattern_id;
                            orHistory.scheduleNo = res.data.schedule_no;
                        } else {
                            //確定日時が未設定の場合
                            orHistory.frameNo = 0;
                            orHistory.patternId = "0";
                            orHistory.scheduleNo = 0;
                        }
                        for (let index = 0; index < res.data.service_list.length; index++){
                            svHistory.push({
                                serviceId:res.data.service_list[index].service_id,
                                serviceName:res.data.service_list[index].service_name,
                                servicePrice:res.data.service_list[index].service_price,
                                serviceQuantity:res.data.service_list[index].service_quantity,
                                serviceTotalPrice:res.data.service_list[index].service_total_price
                            })
                            sumPrice += res.data.service_list[index].service_total_price
                        }
                        for (let index = 0; index < res.data.option_list.length; index++){
                            opHistory.push({
                                optionId:res.data.option_list[index].option_id,
                                optionServiceId:res.data.option_list[index].service_id,
                                optionName:res.data.option_list[index].option_name,
                                optionPrice:res.data.option_list[index].option_price,
                                optionQuantity:res.data.option_list[index].option_quantity,
                                optionTotalPrice:res.data.option_list[index].option_total_price
                            })
                            sumPrice += res.data.option_list[index].option_total_price
                        }
                        sumInt.push({
                            sum:sumPrice
                        })
                        setRefTextArea(memo,res.data.memo);
                        setRefSelect(orderStatus,String(res.data.order_status));
                        setRef(claimMemo,res.data.claim_memo);
                        setRef(updateDate,res.data.update_date);
                        setBillingDate(res.data.billing_date);
                        setOrderHistory(orHistory);
                        setServiceHistory(svHistory);
                        setOptionHistory(opHistory);
                        setSum(sumInt);
                        setRefTextArea(orderComment,res.data.order_comment);
                        setRef(scheduledDate, res.data.scheduled_date);
                        setOrderStatusState(String(res.data.order_status));
                        
                        if (res.data.scheduled_date != null){
                            getScheduleDate();
                        }

                        break;
                    default:
                    //画面のロード失敗時にボタンを非活性にする
                    setSubmitDisabled(true);
                    setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                    }
                }
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changeSccess]);

    return (
        <AdminFrame>
        <div className="contents">
        <mb.MessageBox args={msgArgs}/>
            {/* <div className="breadcrumb"><a href="#" onClick={() => history.goBack()}>← 一覧に戻る</a></div> */}
            <div className="breadcrumb"><a href={sessionStorage.getItem('order_url') ?? ""}>← 一覧に戻る</a></div>
            <h2 className="settings-title-h2">注文管理 &gt; 詳細</h2>
            <div className="order-edit-layout">
            <div className="order-edit-layout-col">
                <div className="settings-block">
                <h3 className="settings-title-h3">基本情報</h3>
                    <div className="settings-form">
                        <div className="form-row control-horizon control-between order-baseinfo-header">
                            <div style={{width: "20%"}}>
                                <div className="form-row-title">注文番号</div>
                                <div className="form-row-input" style={{marginTop: "8px"}} ref={orderNo}>{orderHistory.orderNo}</div>
                            </div>
                            <div style={{width: "20%"}}>
                                <div className="form-row-title">受付日時</div>
                                <div className="form-row-input" style={{marginTop: "8px"}} ref={updateDate}>{spaceSplit(orderHistory.createDate, 0)} {conmaSplit(spaceSplit(orderHistory.createDate, 1),0 ,1)}</div>
                            </div>
                            <div style={{width: "20%"}}>
                                <div className="form-row-title">利用回数</div>
                                {orderHistory.firstTimeFlg === 0
                                    ?<div className="form-row-input" style={{marginTop: "8px"}}>はじめて</div>
                                    :<div className="form-row-input" style={{marginTop: "8px"}}>2回目以降</div>
                                }
                            </div>
                            <div style={{width: "20%"}}>
                                <div className="form-row-title">ステータス</div>
                                <div className="form-row-input">
                                <div className="select">
                                    <select id="statusList" defaultValue={orderHistory.orderStatus} onChange={selectStatus} ref={orderStatus}>
                                        {(() => {
                                            if (orderHistory.orderStatus === 10) {
                                                return(
                                                    <option value="10">受注中</option>
                                                )
                                            } else {
                                                return(
                                                    <option disabled value="10">受注中</option>
                                                )
                                            }
                                        })()}
                                        {(() => {
                                            if (orderHistory.orderStatus === 50 || orderHistory.orderStatus === 99) {
                                                return(
                                                    <option disabled value="20">確定</option>
                                                )
                                            } else {
                                                return(
                                                    <option value="20">確定</option>
                                                )
                                            }
                                        })()}
                                        {(() => {
                                            if (orderHistory.orderStatus === 10 || orderHistory.orderStatus === 99) {
                                                return(
                                                    <option disabled value="50">対応済み</option>
                                                )
                                            } else {
                                                return(
                                                    <option value="50">対応済み</option>
                                                )
                                            }
                                        })()}
                                        {(() => {
                                            if (orderHistory.orderStatus === 50) {
                                                return(
                                                    <option disabled value="99">キャンセル</option>
                                                )
                                            } else {
                                                return(
                                                    <option value="99">キャンセル</option>
                                                )
                                            }
                                        })()}
                                    </select>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="control-horizon">
                                <div style={{width: "50%"}}>
                                    <div className="form-row-title">姓</div>
                                    <div className="form-row-input">
                                        <input type="text" ref={orderName} defaultValue={spaceSplit(orderHistory.orderName, 0)} readOnly/>
                                    </div>
                                </div>
                                <div style={{width: "50%"}}>
                                    <div className="form-row-title">名</div>
                                    <div className="form-row-input">
                                        <input type="text" ref={orderName} defaultValue={spaceSplit(orderHistory.orderName, 1)} readOnly/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="control-horizon">
                                <div style={{width: "50%"}}>
                                    <div className="form-row-title">せい（ふりがな）</div>
                                    <div className="form-row-input"><input type="text" ref={furigana} defaultValue={spaceSplit(orderHistory.furigana, 0)} readOnly/></div>
                                </div>
                                <div style={{width: "50%"}}>
                                    <div className="form-row-title">めい（ふりがな）</div>
                                    <div className="form-row-input"><input type="text" ref={furigana} defaultValue={spaceSplit(orderHistory.furigana, 1)} readOnly/></div>
                                </div>
                            </div>
                        </div>
                            <div className="form-row">
                                <div className="form-row-title">郵便番号</div>
                                <div className="form-row-input"><input type="text" className="input-size-s" ref={zip} defaultValue={orderHistory.zip} readOnly/></div>
                            </div>
                        <div className="form-row">
                            <div className="form-row-title">住所</div>
                            <div className="form-row-input"><input type="text" ref={address} defaultValue={orderHistory.address} readOnly/></div>
                        </div>
                        <div className="form-row">
                            <div className="form-row-title">電話番号</div>
                            <div className="form-row-input control-horizon">
                                <input type="text" className="input-size-s" ref={phone} defaultValue={orderHistory.phone} readOnly/>
                                <button className="btn-row" onClick={function(){window.location.href='tel:' + orderHistory.phone}}><span className="icon material-icons-round md-18">phone_in_talk</span></button>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-row-title">メールアドレス</div>
                            <div className="form-row-input"><input type="text" ref={mailAddress} defaultValue={orderHistory.mailAddress} readOnly/></div>
                        </div>
                        <div className="form-row">
                            <div className="form-row-title">メッセージ</div>
                            <div className="form-row-input"><textarea style={{height: "200px"}} ref={orderComment} readOnly></textarea></div>
                        </div>
                        <div className="form-row">
                            <div className="form-row-title">駐車スペースの有無</div>
                            {(() => {
                                if (orderHistory.parkingSpaceFlg === 0) {
                                    return(
                                        <div className="form-row-input">あり</div>
                                    )
                                } else if (orderHistory.parkingSpaceFlg === 1) {
                                    return(
                                        <div className="form-row-input">近くに有料のパーキングあり</div>
                                    )
                                } else if (orderHistory.parkingSpaceFlg === 2) {
                                    return(
                                        <div className="form-row-input">なし</div>
                                    )
                                }
                            })()}
                        </div>
                    </div>
                </div>
                <div className="settings-block">
                    <h3 className="settings-title-h3">請求情報</h3>
                    <div className="settings-form">
                        <div className="form-row">
                            <div className="form-row-title">見積金額</div>
                            <div className="form-row-input"><span className="text-size-l">{orderHistory.orderTotalPrice.toLocaleString()}</span></div>
                        </div>
                        <div className="form-row control-horizon">
                            <div>
                                <div className="form-row-title">請求金額</div>
                                <div className="form-row-input">
                                    {(() => {
                                        if (orderHistory.orderStatus === 50 || orderHistory.orderStatus === 99) {
                                            return(
                                                <input type="price" className="input-size-s" ref={billingPrice} defaultValue={orderHistory.billingPrice} onChange={priceChangeCheck} readOnly/>
                                            )
                                        } else {
                                            return(
                                                <input type="price" className="input-size-s" ref={billingPrice} defaultValue={orderHistory.billingPrice} onChange={priceChangeCheck}/>
                                            )
                                        }
                                    })()}
                                </div>
                            </div>
                            <div className="control-grow-1">
                                <div className="form-row-title">金額変更理由</div>
                                <div className="form-row-input">
                                    {(() => {
                                        if (orderHistory.orderStatus === 50 || orderHistory.orderStatus === 99) {
                                            return(
                                                <input type="text" ref={claimMemo} defaultValue={orderHistory.claimMemo} readOnly/>
                                            )
                                        } else {
                                            return(
                                                <input type="text" ref={claimMemo} defaultValue={orderHistory.claimMemo}/>
                                            )
                                        }
                                    })()}
                                    
                                </div>
                            </div>
                            
                        </div>
                        <div className="form-row">
                            <div className="form-row-title">請求金額確定日</div>
                            <div className="form-row-input"><span className="text-size-l" defaultValue={orderHistory.billingDate}>{spaceSplit(orderHistory.billingDate, 0)}</span></div>
                        </div>
                    </div>
                </div>
                <div className="settings-block">
                <h3 className="settings-title-h3">メモ</h3>
                <div className="settings-form">
                    <div className="form-row">
                    <textarea style={{height: "100px"}} ref={memo}></textarea>
                    </div>
                </div>
                </div>
            </div>
            <div className="order-edit-layout-col">
                <div className="settings-block">
                <h3 className="settings-title-h3">予約日時</h3>
                <div className="settings-form">
                    <div className="form-row">
                    <ul className="select-date-list">
                        <li className="select-date-decision">
                            <div className="select-date-title">確定日時</div>
                            {orderHistory.orderStatus === 50 || orderHistory.orderStatus === 99
                            ?<div className="select-date-datetime">
                                <InputDate class="input-date" refElm={scheduledDate} onChange={getScheduleDate} disabled/>
                                <div className="select">
                                    <select id="selectScheduleTime" ref={frameNoRef} style={{height:"100%"}} disabled>
                                        <option></option>
                                        {scheduledHistory?.map(function(value, idx){
                                            if (value.scheduleStartTime === "") {
                                                return(<option key={idx} selected disabled>非営業日</option>
                                                )
                                            } else {
                                                if (value.status === 1) {
                                                    return(<option key={idx} value={value.patternId + ":" + value.frameNo} disabled={true}>×{getTimeRange(value.scheduleStartTime, value.scheduleEndTime)}</option>)
                                                } else {
                                                    return(<option key={idx} value={value.patternId + ":" + value.frameNo}>{getTimeRange(value.scheduleStartTime, value.scheduleEndTime)}</option>)
                                                }
                                            }
                                        })}
                                    </select>
                                </div>
                            </div>
                            :<div className="select-date-datetime">
                                <InputDate class="input-date" refElm={scheduledDate} onChange={getScheduleDate}/>
                                <div className="select">
                                    <select id="selectScheduleTime" ref={frameNoRef} style={{height:"100%"}}>
                                        <option></option>
                                        {scheduledHistory?.map(function(value, idx){
                                            if (value.scheduleStartTime === "") {
                                                return(<option key={idx} disabled>非営業日</option>
                                                )
                                            } else {
                                                if (value.status === 1) {
                                                    return(<option key={idx} value={value.patternId + ":" + value.frameNo}>×{getTimeRange(value.scheduleStartTime, value.scheduleEndTime)}</option>)
                                                } else {
                                                    return(<option key={idx} value={value.patternId + ":" + value.frameNo}>{getTimeRange(value.scheduleStartTime, value.scheduleEndTime)}</option>)
                                                }
                                            }
                                        })}
                                    </select>
                                </div>
                            </div>
                            }
                            <div className="select-date-datetime">
                                <label className="checkbox">
                                    {orderHistory.orderStatus === 50 || orderHistory.orderStatus === 99
                                        ?<input type="checkbox" value="" ref={mailRef} disabled={true}/>
                                        :<input type="checkbox" value="" ref={mailRef} disabled={mailCheckBox}/>
                                    }
                                    <div>変更保存時に予約日時確定メールを送信する</div>
                                </label>
                            </div>
                        </li>
                        <li>
                            <div className="select-date-title">第1希望</div>
                            {orderHistory.reserveDate1 == null
                            ?<div className="select-date-datetime">なし</div>
                            :<div className="select-date-datetime">
                                <div className="date">{orderHistory.reserveDate1}{dayWeek[(new Date(orderHistory.reserveDate1).getDay())]}</div>
                                <div className="time">{orderHistory.reserveDateStart1.slice(0, -3)} - {orderHistory.reserveDateEnd1.slice(0, -3)}</div>
                            </div>
                            }
                        </li>
                        <li>
                            <div className="select-date-title">第2希望</div>
                            {orderHistory.reserveDate2 == null
                            ?<div className="select-date-datetime">なし</div>
                            :<div className="select-date-datetime">
                                <div className="date">{orderHistory.reserveDate2}{dayWeek[(new Date(orderHistory.reserveDate2).getDay())]}</div>
                                <div className="time">{orderHistory.reserveDateStart2.slice(0, -3)} - {orderHistory.reserveDateEnd2.slice(0, -3)}</div>
                            </div>
                            }
                        </li>
                        <li>
                            <div className="select-date-title">第3希望</div>
                            {orderHistory.reserveDate3 === null
                            ?<div className="select-date-datetime">なし</div>
                            :<div className="select-date-datetime">
                                <div className="date">{orderHistory.reserveDate3}{dayWeek[(new Date(orderHistory.reserveDate3).getDay())]}</div>
                                <div className="time">{orderHistory.reserveDateStart3.slice(0, -3)} - {orderHistory.reserveDateEnd3.slice(0, -3)}</div>
                            </div>
                            }
                        </li>
                    </ul>
                    </div>
                </div>
                </div>
                <div className="settings-block">
                <h3 className="settings-title-h3">見積内容</h3>
                <div className="settings-form">
                    <div className="tbl-wrap">
                        <table className="tbl tbl-order-mitsumori js-tbl-mitsumori">
                            <thead>
                                <tr>
                                    <th style={{width: "60px"}} className="text-num">No.</th>
                                    <th>名称</th>
                                    <th style={{width: "100px"}} className="text-num">個数</th>
                                    <th style={{width: "120px"}} className="text-price">単価</th>
                                </tr>
                            </thead>

                            {serviceHistory?.map(function(val, idx){
                                return(
                                    <tbody key={idx}>
                                        <tr >
                                            <td className="text-num">{idx+1}</td>
                                            <td >{val.serviceName}</td>
                                            <td className="text-num">{val.serviceQuantity}</td>
                                            <td className="text-price">{val.servicePrice.toLocaleString()}</td>
                                        </tr>
                                        {optionHistory?.map(function(value, ind){
                                            if (val.serviceId === value.optionServiceId){
                                                return(
                                                    <tr key={ind}>
                                                        <td className="text-num"></td>
                                                        <td className="order-edit-list-option">{value.optionName}</td>
                                                        <td className="text-num">{value.optionQuantity}</td>
                                                        <td className="text-price">{value.optionPrice.toLocaleString()}</td>
                                                    </tr>
                                                )
                                            }
                                        })}
                                    </tbody>
                                )
                            })}
                            <tfoot>
                                {sum?.map(function(val, idx){
                                    return(
                                        <tr key={idx}>
                                            <th colSpan={2}></th>
                                            <th style={{width: "120px"}} className="text-price">合計金額</th>
                                            <th className="text-price">{val.sum.toLocaleString()}</th>
                                        </tr>
                                    )
                                })}
                            </tfoot>
                        </table>
                    </div>
                </div>
                </div>
                <div className="order-edit-layout-btn">
                    <div className="control-horizon control-between margin-tb-20">
                        <button className="btn-primary" onClick={clickOpen} disabled={submitDisabled}>変更を保存</button>
                        <Dialog isShow={isShow} setIsShow={setIsShow} callback={clickSave} msg={message}/>
                    </div>
               </div>
            </div>
        </div>
        </div>
        </AdminFrame>
    )
}